module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-dynamix"
  }, [(!_vm.isPrint) ? _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column is-12 has-text-right"
  }, [(!_vm.isIE) ? _c('a', {
    attrs: {
      "href": ('/' + _vm.$route.name + '?type=' + _vm.type + '&print=true'),
      "target": "_blank"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Printer Friendly")]), _vm._v("  \n        "), _c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "18px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": require("../assets/ic_printer.svg"),
      "width": "18"
    }
  })]) : _c('a', {
    attrs: {
      "href": _vm.isPrintPdf,
      "target": "_blank"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Printer Friendly")]), _vm._v("  \n        "), _c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "18px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": require("../assets/ic_printer.svg"),
      "width": "18"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: "item",
      staticClass: "column",
      class: [{
        'is-12': !item.attributes.column
      }, item.attributes.column]
    }, [_c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "control has-icons-right"
    }, [((item.attributes.type === 'checkbox' || item.attributes.type === 'radio')) ? _c('p', {
      staticClass: "label"
    }, [(item.attributes.title && !item.attributes.withDefault && !item.attributes.titleHidden) ? _c('span', [_vm._v("\n              " + _vm._s(item.attributes.title + (_vm.vuelidate.models[item.name].$params.hasOwnProperty('required') || _vm.vuelidate.models[item.name].$params.hasOwnProperty('required_custom') ? ' *' : '')) + "\n            ")]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'checkbox' && item.attributes.withDefault === true) ? _c('label', {
      key: "option.value",
      staticClass: "label default",
      class: [item.attributes.type]
    }, [(!item.attributes.withDefaultHideInput) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      attrs: {
        "type": "checkbox",
        "name": [item.name]
      },
      domProps: {
        "checked": Array.isArray(_vm.models[item.name]) ? _vm._i(_vm.models[item.name], null) > -1 : (_vm.models[item.name])
      },
      on: {
        "clicked": function($event) {
          return item.attributes.onChecked()
        },
        "change": function($event) {
          var $$a = _vm.models[item.name],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.models, item.name, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.models, item.name, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.models, item.name, $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'dropdown') ? _c('div', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$dirty && (_vm.models[item.name] == undefined || _vm.models[item.name] == 0 || _vm.models[item.name].length <= 0) && (_vm.vuelidate.models[item.name].$params.required && !_vm.vuelidate.models[item.name].required)
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.models, item.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((item.attributes.options), function(option) {
      return _c('option', {
        key: "option.value",
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\n                " + _vm._s(option.value !== undefined ? option.title : (option.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : ''))) + "\n              ")])
    }), 0)]) : (item.attributes.type === 'checkbox' || item.attributes.type === 'radio') ? _vm._l((item.attributes.options), function(option) {
      return _c('label', {
        key: "option.value",
        class: [item.attributes.type]
      }, [(item.attributes.type === 'checkbox') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.models[item.name][option.value]),
          expression: "models[item.name][option.value]"
        }],
        attrs: {
          "type": "checkbox",
          "name": [item.name + '-' + item.value],
          "disabled": item.attributes.disabled
        },
        domProps: {
          "checked": Array.isArray(_vm.models[item.name][option.value]) ? _vm._i(_vm.models[item.name][option.value], null) > -1 : (_vm.models[item.name][option.value])
        },
        on: {
          "clicked": function($event) {
            return item.attributes.onChecked()
          },
          "change": function($event) {
            var $$a = _vm.models[item.name][option.value],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.models[item.name], option.value, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.models[item.name], option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.models[item.name], option.value, $$c)
            }
          }
        }
      }) : (item.attributes.type === 'radio') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.models[item.name]),
          expression: "models[item.name]"
        }],
        attrs: {
          "type": "radio",
          "name": [item.name + '-' + item.value],
          "disabled": item.attributes.disabled
        },
        domProps: {
          "value": option.value,
          "checked": _vm._q(_vm.models[item.name], option.value)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.models, item.name, option.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.title))])])
    }) : (item.attributes.type === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.models[item.name]),
        expression: "models[item.name]",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "textarea",
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$dirty
      }],
      attrs: {
        "placeholder": [item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')],
        "maxlength": item.attributes.maxLength
      },
      domProps: {
        "value": (_vm.models[item.name])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.models, item.name, $event.target.value.trim())
        }, function($event) {
          if (item.attributes.onInput) { item.attributes.onInput(_vm.models[item.name], item.attributes); }
        }],
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }) : (item.attributes.type === 'text') ? _c('label', {
      class: [item.attributes.type]
    }, [(!item.attributes.null) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      staticClass: "input",
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$dirty
      }],
      attrs: {
        "placeholder": [item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')],
        "disabled": item.attributes.disabled
      },
      domProps: {
        "value": (_vm.models[item.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.models, item.name, $event.target.value)
        }
      }
    }) : _vm._e()]) : (item.attributes.type === 'label') ? _c('p', {
      staticClass: "label"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.attributes.title)
      }
    }, [_vm._v(_vm._s(item.attributes.title))])]) : (item.attributes.type === 'image') ? _c('p', {
      staticClass: "image-wrapper",
      staticStyle: {
        "text-align": "center"
      }
    }, [(item.attributes.onClick &&
      typeof item.attributes.onClick === 'function') ? _c('a', {
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          item.attributes.onClick()
        }
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.attributes.link
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "gray",
        "font-size": "0.8em"
      }
    }, [_vm._v(_vm._s(item.attributes.title))])]) : (item.attributes.link) ? _c('a', {
      attrs: {
        "href": item.attributes.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.attributes.link
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "gray",
        "font-size": "0.8em"
      }
    }, [_vm._v(_vm._s(item.attributes.title))])]) : _vm._e()]) : (item.attributes.type === 'button') ? _c('p', [_c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "disabled": item.attributes.disabled
      },
      on: {
        "click": function($event) {
          return item.attributes.onClick(item, _vm.models[item.name])
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.attributes.title) + ": " + _vm._s(_vm.models[item.name]) + "\n            ")])]) : _c('p', {
      staticClass: "label"
    }, [_vm._v("\n            Invalid field.\n          ")]), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid) ? _c('span', {
      staticClass: "icon is-small is-right is-danger"
    }, [_c('i', {
      staticClass: "fa fa-warning"
    })]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'text-area') ? _c('small', {
      staticClass: "help counter"
    }, [_vm._v(_vm._s(item.attributes.curLength) + " / " + _vm._s(item.attributes.maxLength))]) : _vm._e(), _vm._v(" "), (item.attributes.note) ? _c('p', {
      staticClass: "help is-note",
      style: (item.attributes.noteStyle),
      domProps: {
        "innerHTML": _vm._s(item.attributes.note)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.required && !_vm.vuelidate.models[item.name].required) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" is required.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.numeric && !_vm.vuelidate.models[item.name].numeric) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" must be numeric value.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.between && !_vm.vuelidate.models[item.name].between) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" must be between " + _vm._s(_vm.vuelidate.models[item.name].$params.between.min) + " and " + _vm._s(_vm.vuelidate.models[item.name].$params.between.max) + ".")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.minLength && !_vm.vuelidate.models[item.name].minLength) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" is too short.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.maxLength && !_vm.vuelidate.models[item.name].maxLength) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" is too long.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.email && !_vm.vuelidate.models[item.name].email) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(item.attributes.title) + " is invalid.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.hasOwnProperty('required_custom') && !_vm.vuelidate.models[item.name].required_custom) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" selection with at least one option.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.hasOwnProperty('either_custom') && !_vm.vuelidate.models[item.name].either_custom) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" selection with conflicting option, please revise.")]) : _vm._e()], 2)])])
  }), 0), _vm._v(" "), (!_vm.isPrint) ? _c('b-field', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column captcha-image-wrapper"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.recaptchaKey
    },
    on: {
      "verify": _vm.onVerifyRecaptcha,
      "expired": _vm.onExpiredRecaptcha,
      "render": _vm.onRenderRecaptcha
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.models['recaptcha']),
      expression: "models['recaptcha']",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.models['recaptcha'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.models, 'recaptcha', $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.vuelidate.models['recaptcha'] && _vm.vuelidate.models['recaptcha'].$dirty && _vm.vuelidate.models['recaptcha'].$invalid && _vm.vuelidate.models['recaptcha'].$params.required && !_vm.vuelidate.models['recaptcha'].required) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Invalid recaptcha.")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isPrint) ? _c('b-field', {
    staticClass: "submit-wrapper"
  }, [_c('button', {
    staticClass: "control button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.vuelidate)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])]) : _vm._e(), _vm._v(" "), (_vm.feedback) ? _c('p', {
    staticClass: "help is-danger",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.feedback))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39ea26c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormDynamix.vue
// module id = 910
// module chunks = 1